export const DEFAULT_TENANT_REGIONAL_SETTINGS = {
  timezone: 'UTC',
  dateFormat: 'd MMM yyyy',
  timeFormat: 'HH:mm',
} as const;

export type TenantRegionalSettings = {
  timezone: string;
  dateFormat: string;
  timeFormat: string;
  modifiedAtUtc?: string;
};

type Listener = (settings: TenantRegionalSettings) => void;

/** Runtime source of truth; never persisted in browser storage. */
class TenantSettingsManager {
  private static instance: TenantSettingsManager;
  private settings: TenantRegionalSettings = {
    ...DEFAULT_TENANT_REGIONAL_SETTINGS,
  };
  private readonly listeners = new Set<Listener>();

  static getInstance(): TenantSettingsManager {
    if (!TenantSettingsManager.instance) {
      TenantSettingsManager.instance = new TenantSettingsManager();
    }
    return TenantSettingsManager.instance;
  }

  getSettings(): TenantRegionalSettings {
    return this.settings;
  }

  setSettings(settings: TenantRegionalSettings): void {
    this.settings = { ...settings };
    this.listeners.forEach((listener) => listener(this.settings));
  }

  reset(): void {
    this.setSettings({ ...DEFAULT_TENANT_REGIONAL_SETTINGS });
  }

  subscribe(listener: Listener): () => void {
    this.listeners.add(listener);
    return () => this.listeners.delete(listener);
  }
}

export default TenantSettingsManager;
